import {
  SettingContext,
  SettingProviderValue,
} from '##/contexts/settingContext';
import { useContext } from 'preact/hooks';

const useSettings = () => useContext(SettingContext) as SettingProviderValue;

export default useSettings;
